module.exports = __webpack_public_path__ + "media/images/checklist-svgrepo-com (1)-16effb35a92ad6c138b9af583116fabc.svg";